import { maxBreakpoints, minBreakpoints } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

export const mobileButtons = css`
  display: none;
  ${mediaQuery(
    { max: maxBreakpoints.M },
    css`
      display: flex;
      width: ${pxToRem(280)};
      justify-content: space-between;
      margin: 0 auto;
    `,
  )};
`;

export const link = css`
  display: block;
`;

export const button = css`
  display: none;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      display: inline-block;
    `,
  )};
`;
